var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CommonUtilsInstance } from "@ane/core/lib/utils/CommonUtils";
var OperatorCategory = /* @__PURE__ */ ((OperatorCategory2) => {
  OperatorCategory2[OperatorCategory2["InOnly"] = 0] = "InOnly";
  OperatorCategory2[OperatorCategory2["InAndNotIn"] = 1] = "InAndNotIn";
  OperatorCategory2[OperatorCategory2["AllOperators"] = 2] = "AllOperators";
  return OperatorCategory2;
})(OperatorCategory || {});
var ValueType = /* @__PURE__ */ ((ValueType2) => {
  ValueType2[ValueType2["predefined"] = 0] = "predefined";
  ValueType2[ValueType2["version"] = 1] = "version";
  ValueType2[ValueType2["integer"] = 2] = "integer";
  return ValueType2;
})(ValueType || {});
class Operator {
  constructor() {
    __publicField(this, "In", "In");
    __publicField(this, "NotIn", "NotIn");
    __publicField(this, "GreaterThan", "GreaterThan");
    __publicField(this, "LessThan", "LessThan");
    __publicField(this, "GreaterThanOrEqual", "GreaterThanOrEqual");
    __publicField(this, "LessThanOrEqual", "LessThanOrEqual");
    __publicField(this, "orderOfOperators", [
      this.In,
      this.NotIn,
      this.GreaterThan,
      this.GreaterThanOrEqual,
      this.LessThan,
      this.LessThanOrEqual
    ]);
  }
  isValidOperator(operator) {
    return operator === this.In || operator === this.NotIn || operator === this.GreaterThan || operator === this.GreaterThanOrEqual || operator === this.LessThan || operator === this.LessThanOrEqual;
  }
  compare(operator1, operator2) {
    return this.orderOfOperators.indexOf(operator1) - this.orderOfOperators.indexOf(operator2);
  }
}
const OperatorConstants = new Operator();
const isRangeOperator = (operator) => operator === OperatorConstants.GreaterThan || operator === OperatorConstants.GreaterThanOrEqual || operator === OperatorConstants.LessThan || operator === OperatorConstants.LessThanOrEqual;
class CustomOperator {
  constructor() {
    __publicField(this, "Between", "Between");
  }
  IsValidOperator(operator) {
    return operator === this.Between;
  }
  getCustomOperatorFromOperatorArray(operatorKeys) {
    if (!operatorKeys || operatorKeys.length === 0) {
      return null;
    }
    if (operatorKeys.length === 1) {
      return operatorKeys[0];
    } else if (operatorKeys.length === 2 && CommonUtilsInstance.belongsTo(operatorKeys[0], [
      OperatorConstants.GreaterThan,
      OperatorConstants.GreaterThanOrEqual
    ]) && CommonUtilsInstance.belongsTo(operatorKeys[1], [OperatorConstants.LessThan, OperatorConstants.LessThanOrEqual])) {
      return this.Between;
    } else {
      return null;
    }
  }
  getDefaultBaseOperators(operatorKey) {
    if (OperatorConstants.isValidOperator(operatorKey)) {
      return [operatorKey];
    } else if (operatorKey === this.Between) {
      return [OperatorConstants.GreaterThanOrEqual, OperatorConstants.LessThan];
    } else {
      return null;
    }
  }
}
const CustomOperatorConstants = new CustomOperator();
export {
  CustomOperator,
  CustomOperatorConstants,
  Operator,
  OperatorCategory,
  OperatorConstants,
  ValueType,
  isRangeOperator
};
//# sourceMappingURL=TrafficFilterModel.js.map
